import TripCard from './TripCardContainer';

export default TripCard;
